import { Button, Stack } from "@mui/material";
import { useId } from "react";
import AppDialog from "./AppDialog";

export default function FormDialog({
  children,
  submitLabel = "Save",
  cancelLabel = "Cancel",
  onSubmit,
  onClose,
  submitting = false,
  submitDisabled = false,
  actions,
  formProps,
  ...dialogProps
}) {
  const generatedFormId = useId();
  const formId = formProps?.id || generatedFormId;
  const content = onSubmit ? (
    <Stack component="form" id={formId} spacing={2.5} onSubmit={onSubmit} noValidate {...formProps}>{children}</Stack>
  ) : children;

  return (
    <AppDialog
      onClose={onClose}
      loading={submitting}
      {...dialogProps}
      actions={actions ?? <><Button onClick={onClose} disabled={submitting}>{cancelLabel}</Button><Button type={onSubmit ? "submit" : "button"} form={onSubmit ? formId : undefined} variant="contained" disabled={submitting || submitDisabled}>{submitting ? "Saving…" : submitLabel}</Button></>}
    >
      {content}
    </AppDialog>
  );
}
